import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

export function validationFunctionDocumentType(values) {
  const errors = {};
  // Custom Validations
  return errors;
}

export const validationSchemaDocumentType = Yup.object().shape({
  name: Yup.string().required(),
});
